import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { IsStaticTagEmptyPipe } from './is-static-tag-empty.pipe';

import { StaticTagComponent } from './static-tag.component';

@NgModule({
  imports: [CommonModule],
  exports: [StaticTagComponent],
  declarations: [StaticTagComponent, IsStaticTagEmptyPipe],
  providers: [],
})
export class StaticTagModule {}
